import  React, {useState, useContext} from 'react';
import WCLoginService from '../services/WCLoginService';
import {LoaderDispatch} from "../context/LoaderContext";
import {useLanguage} from "../context/LanguageContext";

const RegistrationForm = ({onRegisterSuccess}) => {
    const {t} = useLanguage();
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const loaderDispatch = useContext(LoaderDispatch);

    const handleRegister = async (e) => {
        loaderDispatch({type: 'activate'});
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (password !== confirmPassword) {
            setError(t('auth.passwordsMismatch'));
            loaderDispatch({type: 'deactivate'});
            return;
        }

        const response = await WCLoginService.registerCustomer({username, email, password});
        //console.log(response);
        if (response.status === 'error') {
            setError(response.message);
            loaderDispatch({type: 'deactivate'});
            return;
        }
        if (response.status === 'success') {
            setSuccess(response.message);
            loaderDispatch({type: 'deactivate'});
            if (onRegisterSuccess) {
                setTimeout(() => {
                    onRegisterSuccess();
                }, 2000);
            }
            return;
        }

        setTimeout(() => {
            setError(null);
            setSuccess(null);
        }, 2000);
    };

    return (
        <div className="row justify-content-center">
            <div className="col-12 col-md-8">
                <form onSubmit={handleRegister} aria-label={t('auth.registrationFormLabel')}>
                    <div className="mb-3">
                        <label htmlFor="username" className="form-label">{t('auth.username')}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            aria-required="true"
                            aria-label={t('auth.username')}
                            autoComplete="username"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">{t('auth.email')}</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            aria-required="true"
                            aria-label={t('auth.email')}
                            autoComplete="email"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">{t('auth.password')}</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            aria-required="true"
                            aria-label={t('auth.password')}
                            autoComplete="new-password"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="confirmPassword" className="form-label">{t('auth.confirmPassword')}</label>
                        <input
                            type="password"
                            className="form-control"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            aria-required="true"
                            aria-label={t('auth.confirmPassword')}
                            autoComplete="new-password"
                        />
                    </div>
                    <div className="row">
                        <button style={{margin: "2rem auto"}} type="submit" className="btn btn--secondary" aria-label={t('auth.register')}>{t('auth.register')}</button>
                    </div>
                    {error && <div className="alert alert-danger" role="alert">{error}</div>}
                    {success && <div className="alert alert-success" role="alert">{success}</div>}
                </form>
            </div>
        </div>

    );
};

export default RegistrationForm;
